export enum LearningMethodEnum {
    Lectures = "118950000",
    Workshops = "118950001",
    Tutorials = "118950002",
    DiscussionGroups = "118950003",
    Demonstrations = "118950004",
    Practicals = "118950005",
    OnlineELearning = "118950006",
    Quizzes = "118950007",
    MCQ = "118950008",
    PosterPresentationsModerated = "118950009",
    PosterPresentationsUnmoderated = "118950010",
    Other = "118950011"
}